<style scoped>
@import url("../assets/css/detail.css");
</style>

<template>
    <div>
        <div class="page-loading" v-show="!show">
            <div class="loading-content">
                <img src="../assets/images/page_loading.gif">
                <p class="title">正在加载...</p>
            </div>
        </div>
        <div class="detail-home common-home-content" v-show="show">
            <div class="section2 ice_bg section-bor-bom">
                <h2>诊断</h2>
                <div class="p-content pr">
                    <p v-if="locData.diagnosis">{{locData.diagnosis}}</p>
                    <p v-else>暂无诊断结果</p>
                </div>
            </div>
            <div class="section1 ice_bg" v-if="locData.cause">
                <h2>分析</h2>
                <div class="p-content pr">
                    <p class="symptoms_panel" data-key="symptoms">
                    {{locData.cause}}
                    </p>
                </div>
            </div>
            <div class="section1 ice_bg mt5" v-if="locData.cheng || locData.fang">
                <h2>诊疗建议</h2>
                <div class="p-content pr" v-if="locData.cheng">
                    <p class="sub_title">【中成药】</p>
                    <div class="pr icon-composition">
                        <span class="br-t-l ice_bg"></span>
                        <span class="br-t-r ice_bg"></span>
                        <span class="br-b-l ice_bg"></span>
                        <span class="br-b-r ice_bg"></span>
                        <p class="copy_composition products_name">{{locData.cheng}}</p>
                    </div>

                    <div v-if="recommendData.type == 3">
                        <p class="sub_title pr mt10">【中药方】
<!--                          <span class="recommend-medicine-buy" @click="toBuyMedicine(recommendData.info)">去购买</span>-->
                        </p>
                        <div class="pr icon-composition">
                            <span class="br-t-l ice_bg"></span>
                            <span class="br-t-r ice_bg"></span>
                            <span class="br-b-l ice_bg"></span>
                            <span class="br-b-r ice_bg"></span>
                            <p class="copy_composition" data-key="prescription">{{recommendData.info.name}}：<span v-for="(medicine,index) in recommendData.info.content" :key="index">{{medicine.name}}{{medicine.quantity}}{{unitFormat(medicine.unit)}} </span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section ice_bg mt5" v-if="locData.anli">
                <div class="mb15 clearfix">
                    <h2 class="mtt-h2 fl" v-if="locData.anli.head">{{locData.anli.head}}</h2>
                    <h2 class="mtt-h2 fl" v-else>参考病例</h2>
                </div>
                <div class="mtc">
                    <p class="mc-anli-p1 fb">{{locData.anli.anname}}</p>
                    <p class="mc-anli-p2">
                        <span class="fb mr10 name">{{locData.anli.doc_name}}</span>{{locData.anli.title}} <span v-if="locData.anli.zhi">{{locData.anli.zhi}}</span><span v-if="locData.anli.section">（{{locData.anli.section}}）</span>
                        <p class="mc-anli-text" v-for="(child,index) in locData.anli.text" :key="index">{{child}}</p>
                    <!-- <p class="mc-anli-text">……</p> -->
                </div>
            </div>

            <div class="section ice_bg mt5" v-if="locData.jiu">
                <div class="mb15 clearfix">
                    <h2 class="mtt-h2 fl" v-if="locData.jiu.head">{{locData.jiu.head}}</h2>
                    <h2 class="mtt-h2 fl" v-else>针灸治疗</h2>
                </div>
                <div class="mtc">
                    <p class="mc-anli-p1 fb">{{locData.jiu.anname}}</p>
                    <p class="mc-anli-p2">
                        <span class="fb mr10 name">{{locData.jiu.doc_name}}</span>{{locData.jiu.title}} <span class="ml5" v-if="locData.jiu.zhi">{{locData.jiu.zhi}}</span><span v-if="locData.jiu.section">（{{locData.jiu.section}}）</span>
                        <p class="mc-anli-text" v-for="(child,index) in locData.jiu.text" :key="index">{{child}}</p>
                    <!-- <p class="mc-anli-text">……</p> -->
                </div>
            </div>

            <div class="section ice_bg mt5" v-if="locData.nature">
                <div class="mb15 clearfix">
                    <h2 class="mtt-h2 fl" v-if="locData.nature.head">{{locData.nature.head}}</h2>
                    <h2 class="mtt-h2 fl" v-else>自然疗法</h2>
                </div>
                <div class="mtc">
                    <p class="mc-anli-p1 fb">{{locData.nature.name}}</p>
                    <p class="mc-anli-text" v-for="(child,index) in locData.nature.text" :key="index">{{child}}</p>
                    <!-- <p class="mc-anli-text">……</p> -->
                </div>
            </div>
          <div style=" background: #fff; margin-bottom: 20px;padding: 10px; box-sizing: border-box;">
            <div style=" padding: 10px;box-sizing: border-box;border-radius: 15px;background: #E6F6E9;">
              <p style=" padding-bottom: 4px;color: #578F4E;">参考引源：</p>
              <p style="color: #4E894F; word-break: break-word">我们的测试，所涉及的医疗、养生内容均由神黄中医智库联合中医专家审校通过后发布。相关测试量表内容已先在微信公众号(id:zk120com)或头条号(id:神黄中医智库)上审核发布。https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzAxOTIzMTc1NA==&action=getalbum&album_id=2877305962636967940#wechat_redirect</p>
            </div>
          </div>
            <div class="recommend-content ice_bg mt5" v-if="recommendData.type == 1">
                <p class="title">推荐医生</p>
                <div class="doctor-content" @click="toAskDoctor(recommendData.info.id)">
                    <div class="avatar">
                        <img :src="recommendData.info.avatar" v-if="recommendData.info.avatar" alt="头像" />
                        <img src="../assets/images/default_doctor.png" v-else alt="头像" />
                    </div>
                    <p class="name-studio-price"><span class="name">{{recommendData.info.name}}</span><span class="studio" v-if="recommendData.info.studio_name">{{recommendData.info.studio_name}}</span><span class="price" v-html="priceFormat(recommendData.info.price)"></span></p>
                    <p class="title-department">{{recommendData.info.title}} {{recommendData.info.department}}</p>
                    <p class="skill">{{recommendData.info.skill}}</p>
                    <p class="diagnose-favorable"><span class="item">接诊率：{{recommendData.info.diagnose_rate}}</span><span class="item">好评率：{{recommendData.info.favorable_rate}}</span><span class="item">咨询量：{{recommendData.info.diagnosed_count}}</span></p>
                    <p class="tags">
                        <span class="tag gold-medal" v-if="recommendData.info.tags[0]">{{recommendData.info.tags[0]}}</span>
                        <span class="tag response" v-if="recommendData.info.tags[1]">{{recommendData.info.tags[1]}}</span>
                    </p>
                </div>
            </div>
<!--            <div class="recommend-content ice_bg mt5" v-if="recommendData.type == 2">-->
<!--                <p class="title">推荐好物</p>-->
<!--                <div class="resource-content">-->
<!--                    <div class="picture">-->
<!--                        <img :src="recommendData.info.img_url_compress" alt="图片" />-->
<!--                    </div>-->
<!--                    <p class="name">{{recommendData.info.title}}</p>-->
<!--                    <p class="summary">{{recommendData.info.summary}}</p>-->
<!--                    <p class="price" :class="recommendData.info.line_price > 0?'price-margin':''" v-html="priceFormat2(recommendData.info.price)"></p>-->
<!--                    <p class="line_price" v-if="recommendData.info.line_price"><span class="through" v-html="priceFormat2(recommendData.info.line_price)"></span></p>-->
<!--                    <div class="buy" @click="toMiniProgram(recommendData.type, recommendData.info.resource_id)">立即购买</div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="btns-content clearfix">
                <button class="left fl" :class="!free_doctor_show?'long':''" @click="pageback()">重新自测</button>
<!--                <button class="right fr" v-show="free_doctor_show" @click="toAskDoctor(false)">免费问医生</button>-->
            </div>
        </div>
    </div>
</template>

<script>
import http from '../assets/api/friggApiConfig'
import http2 from '../assets/api/hermerApiConfig'
import http3 from '../assets/api/dorisApiConfig'
import doctor_show from '../assets/api/doctorApiConfig'
import h5_url from '../assets/api/h5ApiConfig'
export default {
  data() {
    return {
      locData: {},
      recommendData: {},
      detailId: null,
      free_doctor_show: 0,
      show: false
    };
  },
  created() {
      this.detailId = this.$route.params.detail_id;
      this.free_doctor_show = doctor_show;
      this.getRecommendData();
      this.loadinit();
      window.appBack = ()=> this.pageback();
  },
  methods: {
      unitFormat(unit){
          if(unit == '克'){
              return 'g';
          }
          return unit;
      },
      priceFormat(price){
          price = (price*100/100).toFixed(2);
          price = price.split('.');
          return '<span style="font-size: 12px;">￥</span>' + price[0] + '.' + '<span style="font-size: 12px;">'+price[1]+'</span>';
      },
      priceFormat2(price){
          price = (price/100).toFixed(2);
          price = price.split('.');
          return '<span style="font-size: 12px;">￥</span>' + price[0] + '.' + '<span style="font-size: 12px;">'+price[1]+'</span>';
      },
      getRecommendData(){
        var that = this;
        var param = {"type": 2}
        http2.get("/goods/recommend", {params: param}).then(function(res) {
            that.recommendData = res.data.data;
        });
      },
      toBuyMedicine(item){
        let that = this;
        if(that.$appUtils.appIsLogin()){
            let params = {
                prescription_name: item.name
            }
            http3.get("/drugs/prescription/info", {params: params}).then(function(res) {
                if(res.data.status_code == 200){
                    let obj = {
                        name: item.name,
                        content: item.content,
                        price: res.data.data.price,
                        num: 1
                    }
                    window.location.href = h5_url + "/medicineorder?t=1&obj="+JSON.stringify(obj);
                }else{
                    that.$layer.msg(res.data.msg);
                }
            });
        }
      },
      toMiniProgram(type, id){
          this.$appUtils.appOpenMiniProgram({"type": type, "id": id});
      },
      toAskDoctor(id){
          if(id){
              this.$appUtils.appAskDoctor({"page_type":"doctor_detail", "doctor_id": id});
          }else{
              this.$appUtils.appAskDoctor({"page_type":"doctor_list"});
          }
      },
      loadinit(){
        var that = this;
        http.get("/zhen/goods/default_solution/" + that.detailId).then(function(res) {
            that.locData = res.data.answer;
            that.show = true;
        });
      },
      pageback(){
          //this.$router.push({ path: "/"});
          window.history.go(-2);
          return true;
      }
  }
}
</script>

